import React from 'react';

import type { LinkPreviewData } from './../ricos-types/index.js';
import { LinkPreviewPopover } from './../link-preview-popover/LinkPreviewPopover.js';

interface Props {
  container: HTMLElement;
  fetchUrlPreviewData: (url: string) => Promise<LinkPreviewData>;
}

const PreviewPopover: React.FC<Props> = ({ container, fetchUrlPreviewData }) => {
  return <LinkPreviewPopover container={container} fetchUrlPreviewData={fetchUrlPreviewData} />;
};

export default PreviewPopover;
